import constants from '../../shared/constants'

export function state_label(state) {
  return constants.states.labels[state] || state
}

export function state_class(state) {
  return `small ${constants.states.classes[state] || state}`
}

export function gender(g) {
  return constants.genders[g] || ''
}

export function is_number(n) {  
  return !isNaN(parseFloat(n)) && isFinite(n)  
}  

export function money(n) {
  return (n != null && n !== 0 && is_number(n)) ?
    n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
    '-'
}

export function pay_unit_month(month) {
  if (constants.rent_pay_unit_month[month])
    return constants.rent_pay_unit_month[month]
  return constants.rent_pay_unit_month.default(month)
}

export function duration_months(month) {
  return `${month} 个月`
}

export function payment_method(key, methods = []) {
  const obj = (methods || []).filter(({ name }) => key === name)[0] || {}
  return obj.display || key
}

export function customers_summary(customers) {
  if (customers)
    return customers.map(c => c.name).filter(n => n).join(', ')
  return ''
}

export function limited(text = '', length = 20) {
  return text.length > length ?
    `${text.substring(0, length)}...` :
    text
}

export function utility_label(type) {
  return constants.utilities.labels[type] || type
}

export function utility_unit(type) {
  return constants.utilities.units[type] || ''
}

export function utility_price(type) {
  return constants.utilities.price[type] || 0
}

export function bill_action(type) {
  return constants.bills.actions[type] || type || '-'
}

export function number_to_word(number) {
  return [
    '', 'one', 'two', 'three', 'four', 'five',
    'six', 'seven', 'eight', 'night', 'ten',
  ][number] || number
}

export function to_chinese_upcase(number) {
  const numbers = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖', '拾']
  const levels = ['', ' 拾 ', ' 佰 ', ' 仟 ', ' 万 ', '拾']

  let result = ''
  let m = number
  let level = 0
  let zero = true
  while (m) {
    const digit = m % 10
    if (digit) {
      result = numbers[digit] + levels[level] + result
      zero = false
    } else if (!zero) {
      result = numbers[digit] + result
      zero = true
    }
    m = Math.floor(m / 10)
    level += 1
  }
  return result
}

export function text_capitalize(string) {
  if (string && typeof string === 'string')
    return string.charAt(0).toUpperCase() + string.slice(1)
  return string
}

export function user_name(user) {
  return text_capitalize(user.display || user.username || '游客')
}

export function user_role(user) {
  if (user.roles && Array.isArray(user.roles))
    return user.roles.map(r => text_capitalize(r)).join(', ')
  return user.roles || '游客'
}

export function to_percent(value, digit = 2) {
  return `${(value * 100).toFixed(digit)}%`
}

export function native_error_message(text) {
  const formatted = text.replace('$error', '').trim().replace(/ /g, '_')
  return constants.native_errors[formatted] || formatted
}



// WEBPACK FOOTER //
// ./modules/formatters/text.js